module.exports = __webpack_public_path__ + "capacitor.f5cf97.svg";